import { SitePaymentsService } from 'src/app/shared/services/site-payments.service';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../../../../shared/interfaces/company';
import { CompanyService } from '../../../../shared/services/company.service';
import { BRAND } from 'src/app/shared/brand';
import { ENTITY_SENTENCE } from 'src/app/shared/services/root.service';

@Component({
    selector: 'app-footer-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent {
    /// The brand, for the template (shared/brand.ts).
    readonly brand = BRAND;
    /// What the shop is, in its one sentence.
    readonly entity = ENTITY_SENTENCE;

    readonly company$: Observable<Company | null>;
    readonly cards$: Observable<boolean>;

    constructor(companies: CompanyService, payments: SitePaymentsService) {
        this.company$ = companies.company$;
        this.cards$ = payments.cards$;
    }
}
